// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Object,
  type: string,
  className?: string,
  vertical?: string,
};

export const CardMetaInfo = (props: Props) => {
  const { data, type, className, vertical } = props;
  const rowClassName = classNames('first-row', className);
  const renderProductArea = (max_area, min_area) => {
    let display_area =
      min_area && !max_area
        ? min_area
        : max_area && !min_area
        ? max_area
        : `${min_area} - ${max_area}`;
    return <span>{display_area} SQ.FT.</span>;
  };

  return (
    <div className={'card-meta-container'}>
      {type !== 'products' ? (
        <>
          <div className={rowClassName}>
            <span>
              {data.city}, {data.country}
            </span>
            {data.distance && <span>{data.distance}</span>}
          </div>
          <h3>{data.name}</h3>
          {vertical === 'architects' ? (
            <div className={'project-extra-info'}>
              <span>{data.propertyType}</span>
              <span>{data.projectCompletionText}</span>
              <span>{data.copyrightText}</span>
            </div>
          ) : null}
        </>
      ) : (
        <>
          <h3>
            {data.detailCard.productName}
            <h4 className={'product-version'}>
              {data.detailCard.productVersion}
            </h4>
          </h3>
          <div className={'product-meta'}>
            {!data.detailCard.min_area && !data.detailCard.max_area ? (
              <></>
            ) : (
              renderProductArea(
                data.detailCard.max_area,
                data.detailCard.min_area
              )
            )}
            <span>
              <i className={'fa fa-bed'}></i> {data.detailCard.bedrooms}
              bedrooms &nbsp; &nbsp;
              <i className={'fa fa-shower'}></i>
              {data.detailCard.bathrooms} bathrooms
            </span>
          </div>
        </>
      )}
    </div>
  );
};
